// @flow

import { values, flatten, get, map, mapValues, flow, filter, pickBy, keys, sumBy } from 'lodash/fp';

import * as challengesApi from '../api/challenges';
import {
  INCREMENT_PENDING_ENTRY,
  DECREMENT_PENDING_ENTRY,
  API_CALL,
  SUBMIT_MULTIPLE_REQUEST,
  SUBMIT_MULTIPLE_FAILURE,
  SUBMIT_MULTIPLE_SUCCESS,
  RESET_COMPATIBLE_CHALLENGES,
  TOGGLE_SHOW_CUSTOM,
  TOGGLE_SHOW_H2H
} from '../constants/actionTypes';
import { COMPATIBLE_CHALLENGES } from '../constants/apiTypes';

const mapToId = map('id');

export function getCompatibleChallenges(query) {
  return {
    type: API_CALL,
    api: COMPATIBLE_CHALLENGES,
    request: challengesApi.getCompatibleChallenges(query)
  };
}

export function incrementPendingEntry(challengeId: string) {
  return {
    type: INCREMENT_PENDING_ENTRY,
    challengeId
  };
}

export function decrementPendingEntry(challengeId: string) {
  return {
    type: DECREMENT_PENDING_ENTRY,
    challengeId
  };
}

export function resetCompatibleChallenges() {
  return {
    type: RESET_COMPATIBLE_CHALLENGES
  };
}

export function toggleShowCustom() {
  return {
    type: TOGGLE_SHOW_CUSTOM
  };
}

export function toggleShowH2H() {
  return {
    type: TOGGLE_SHOW_H2H
  };
}

export function submitMultipleEntries() {
  return (dispatch: Dispatch<*>, getState: GetState) => {
    const {
      compatibleChallenges: { pendingEntries, challenges },
      entry: { myEntry }
    } = getState();

    dispatch({
      type: SUBMIT_MULTIPLE_REQUEST
    });

    const filteredPendingEntries = flow(
      pickBy(count => count),
      keys
    )(pendingEntries);

    const totalCost = sumBy(ch => pendingEntries[ch.id] * ch.cost, challenges);

    const bonusesSubmitted: Array<{
      key: string,
      player_id: string
    }> = flow(
      values,
      flatten,
      filter('bonus'),
      map(player => ({
        key: player.bonus.key,
        player_id: player.id
      }))
    )(myEntry.playersSubmitted);

    Promise.all(
      filteredPendingEntries.map((challengeId, i) =>
        new Promise(resolve => setTimeout(resolve, i * 800)).then(() =>
          challengesApi
            .submitMultipleEntries(challengeId, {
              selection: {
                players: mapValues(mapToId, myEntry.playersSubmitted),
                teams: mapToId(myEntry.teamsSubmitted),
                bonus_selections: bonusesSubmitted
              },
              quantity: pendingEntries[challengeId]
            })
            .then(payload => ({
              ...payload,
              challengeId,
              errors: get('meta.soft_errors', payload)
            }))
            .catch(e => ({ errors: get('errors', e) }))
        )
      )
    ).then(
      payload => {
        dispatch({
          type: SUBMIT_MULTIPLE_SUCCESS,
          payload,
          totalCost
        });
      },
      payload => {
        dispatch({
          type: SUBMIT_MULTIPLE_FAILURE,
          payload
        });
      }
    );
  };
}

export function submitMultiplePxcEntries(data = {}) {
  return (dispatch: Dispatch<*>, getState: GetState) => {
    const {
      compatibleChallenges: { pendingEntries },
      entry: { myEntry }
    } = getState();

    dispatch({
      type: SUBMIT_MULTIPLE_REQUEST
    });

    const filteredPendingEntries = flow(
      pickBy(count => count),
      keys
    )(pendingEntries);

    const challenges = [];

    filteredPendingEntries.map(id =>
      challenges.push({
        id,
        quantity: pendingEntries[id]
      })
    );

    const bonusesSubmitted: Array<{
      key: string,
      player_id: string
    }> = flow(
      values,
      flatten,
      filter('bonus'),
      map(player => ({
        key: player.bonus.key,
        player_id: player.id
      }))
    )(myEntry.playersSubmitted);

    const challengeData = {
      selection: {
        players: mapValues(mapToId, myEntry.playersSubmitted),
        teams: mapToId(myEntry.teamsSubmitted),
        bonus_selections: bonusesSubmitted
      },
      challenges
    };

    if (data && data.batchId) {
      challengeData.transfer_id = data.batchId;
    }

    Promise.all([
      challengesApi
        .submitPxcEntries(challengeData)
        .then(payload => ({
          ...payload,
          errors: get('meta.soft_errors', payload)
        }))
        .catch(e => ({ errors: get('errors', e) }))
    ]).then(
      payload => {
        dispatch({
          type: SUBMIT_MULTIPLE_SUCCESS,
          payload
        });
      },
      payload => {
        dispatch({
          type: SUBMIT_MULTIPLE_FAILURE,
          payload
        });
      }
    );
  };
}
